module.exports = __webpack_public_path__ + "static/media/015.0569560d.jpg";